import React from 'react';
import {
  Text,
  Heading,
  TEXT_VARIANTS,
  HEADING_VARIANTS,
} from 'components/ui/Typography';
import { routes } from 'constants/config';
import noResultsCompass from 'images/no_results_compass.svg';
import ReactHtml from 'components/shared/ReactHtml';
import createHtmlLink from 'components/shared/ReactHtml/create-html-link';

const createLink = query =>
  createHtmlLink(
    routes.ARCHIVES({ query }),
    t('contents.advanced_search.no_results.archive_suggestion_link_text'),
    { className: 'u-linkBtn mb-24 d-ib' },
  );

const NoResults = ({ query }) => {
  return (
    <div className="ta-c d-f fd-c jc-c ai-c">
      <img
        className="mt-24 h-100p"
        src={noResultsCompass}
        alt="no results icon"
      />
      <Heading className="py-8" variant={HEADING_VARIANTS.H4}>
        {t('contents.advanced_search.no_results.heading')}
      </Heading>
      <div className="mw-450 d-f fd-c">
        <Text variant={TEXT_VARIANTS.BODY}>
          {t('contents.advanced_search.no_results.suggestion')}
        </Text>
        <Text className="mt-24" variant={TEXT_VARIANTS.BODY}>
          <ReactHtml component="span">
            {t('contents.advanced_search.no_results.archive_suggestion_html', {
              link: createLink(query),
            })}
          </ReactHtml>
        </Text>
      </div>
    </div>
  );
};

export default NoResults;
